<div>
  <h1 *ngIf="title">{{title}}</h1>
  <div [innerHtml]="message"></div>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="confirm()">{{this.confirmText || 'Yes'}}</button>
    <button mat-raised-button (click)="cancel()">{{this.cancelText || 'No'}}</button>
  </div>
</div>